module.exports = __webpack_public_path__ + "img/dokhan.ee2bfde3.jpg";